<template>
  <div>
    <!-- :item-disabled="" -->
    <VAutocomplete 
      :search-input.sync="search_"
      cache-items
      :items="propsg.items"
      v-bind="propsg"
      :item-disabled="propsg['item-disabled']"
      v-on="$listeners"
    >
      <template v-slot:label> 
        <span><span
          v-show="propsg.required"
          style="color:red"
        >*</span>{{ propsg.label }}</span>
      </template>
      <template
        v-if="propsg.item_slot"
        v-slot:item="{item}"
      >
        <Cc 
          :render="propsg.item_slot"
          :item="item"
        />
      </template>
    </VAutocomplete>
  </div>
</template>
<script>
  import { VAutocomplete } from 'vuetify/lib'
  const Cc = {
    props: {
      render: {
        type: Function,
      },
      item: {
        type: Object
      }
    },
    render(h) {
      return this.render(h, this.item)
    }
  }
  export default {
    components: {
      VAutocomplete,
      Cc
    },
    props: {
      propsg: {
        type: Object,
        default: () => ({}),
      },
      callBacks: {
        type: Function
      }
    },
    data() {
      return {
        search_:''
      };
    },
    watch: {
      search_(val) {
        this.callBacks && this.callBacks(val)
      },
    },
    mounted() {
      //  console.log('this', this.propsg)
    }
  }
</script>
    